<div class="overlay" *ngIf="loading">
  <div class="spinner-wrapper">
    <app-spinner><span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span></app-spinner>
  </div>
</div>
<div style="width:100%">
  <button (click)="toggleEdit()" [hidden]="!editmode || id == 0" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-times"></i> Cancel</button>
  <button (click)="saveClient()" [hidden]="!editmode" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-save"></i> Save</button>
  <button (click)="toggleEdit()" [hidden]="editmode" class="float-right" style="margin-right:10px;margin-left:10px" *hasClaim="'Client_Edit'"><i class="fa fa-pencil"></i> Edit</button>
</div>
<div>
  <label for="client-name">Client Name</label>
  <input id="client-name" type="text" size="30" [(ngModel)]="this.client.Name" [hidden]="!editmode" [style]="{'width':'400px'}">
  <span [hidden]="editmode">{{this.client.Name}}</span>
</div>
<div>
  <label for="client-code">Client Code</label>
  <input id="client-code" type="text" size="30" [(ngModel)]="client.Code" [hidden]="!editmode" [style]="{'width':'200px'}">
  <span [hidden]="editmode">{{client.Code}}</span>
</div>
<div>
  <label for="gender">Processing Type</label>
  <p-select [options]="processingTypes" [(ngModel)]="client.ProcessingType"  (onChange)="processingTypeOnChange()" [hidden]="!editmode" [style]="{'width':'150px'}"></p-select>
  <span [hidden]="editmode">{{client.ProcessingTypeLabel}}</span>
</div>

<hr />
<div [hidden]="editmode">
  <div>
    <label>Address</label>
    {{client.Address1}}
  </div>
  <div [hidden]="!client.Address2">
    <label> </label>
    {{client.Address2}}
  </div>
  <div>
    <label> </label>
    {{client.City}}, {{client.State}} {{client.ZipCode}}
  </div>
</div>
<div [hidden]="!editmode">
  <div>
    <label for="address1">Address Search <i class="fa fa-search"></i></label>
    <!--<input ngx-google-places-autocomplete [options]='options' (onAddressChange)="AddressChange($event)" style="width: 450px;" />-->
  </div>
  <div>
    <label for="address1">Address Line 1</label>
    <input #street id="address1" type="text" size="40" [(ngModel)]="client.Address1">
  </div>
  <div>
    <label for="address2">Address Line 2</label>
    <input id="address2" type="text" size="40" [(ngModel)]="client.Address2">
  </div>
  <div>
    <div class="float-left">
      <label for="city">City, State, Zip</label>
      <input #city id="city" type="text" size="20" [(ngModel)]="client.City">
    </div>
    <div class="float-left ml-2">
      <select #state [(ngModel)]="client.State" style="height:30px">
        <option *ngFor="let x of states" value="{{x.value}}">{{x.label}}</option>
      </select>
    </div>
    <div class="float-left ml-2">
      <input #zip type="text" size="9" [(ngModel)]="client.ZipCode">
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<div class="clearfix"></div>
<hr />
<div class="shadowbox" style="clear:both; margin-top: 60px; ">
  <div class="row">
    <div class="col-3">
      <h4>Providers</h4>
    </div>
    <div class="col-9">
      <a (click)="addProvider()" style="cursor:pointer;" [hidden]="!editmode"><i class="fa fa-plus"></i></a>
    </div>
  </div>

  <div *ngFor="let provider of client.Providers; index as i" class="row border-bottom">
    <div class="col-2" [hidden]="!editmode"><a (click)="removeProvider(i)"><i class="fa fa-trash"></i></a></div>
    <div class="col-3">{{provider.ProviderNPI}}</div>
    <div class="col-7">{{provider.ProviderName}}</div>
  </div>
  <div [hidden]="client.Providers != null && client.Providers.length > 0" style="padding:8px; font-style: italic;">
    No providers have been added to this client
  </div>
</div>
<!--FACILITY SECTION-->
<div class="shadowbox" style="clear:both; ">
  <div class="row">
    <div class="col-3">
      <h4>Facilities</h4>
    </div>
    <div class="col-9">
      <a (click)="addFacility()" style="cursor:pointer;" [hidden]="!editmode"><i class="fa fa-plus"></i></a>
    </div>
  </div>

  <div *ngFor="let facility of client.Facilities; index as i" class="row border-bottom">
    <div class="col-2" [hidden]="!editmode"><a (click)="removeFacility(i)"><i class="fa fa-trash"></i></a></div>
    <div class="col-3">{{facility.FacilityCode}}</div>
    <div class="col-7">{{facility.FacilityName}}</div>
  </div>
  <div [hidden]="client.Facilities != null && client.Facilities.length > 0" style="padding:8px; font-style: italic;">
    No facilities have been added to this client
  </div>
</div>
<p-toast></p-toast>
